export default {"src":"/_next/static/media/icon_business.6a513d8a.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};